var exports = {
  "kL": "xf61da738--7b262d--container",
  "Kk": "xf61da738--7b262d--icon",
  "UU": "xf61da738--7b262d--name",
  "vd": "xf61da738--7b262d--travel-time",
  "IC": "xf61da738--7b262d--travel-time-unit",
  "OQ": "xf61da738--7b262d--highway-distance",
};

module.exports = exports;
